import { render, staticRenderFns } from "./ChangeMethodSettings.vue?vue&type=template&id=9a8a7660&"
import script from "./ChangeMethodSettings.vue?vue&type=script&lang=ts&"
export * from "./ChangeMethodSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports